import { Model } from '@vuex-orm/core'

export default class Member extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'members'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      active: this.attr(null),
      name: this.attr(null),
      user_id: this.attr(null),
      token: this.attr(null),
      accept_access: this.attr(null),
      photo_media_id: this.attr(null),
      photo_media_url: this.attr(null),
      timezone: this.attr(null),
      role_id: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Member.js